export const hasEnoughPhotosUploaded = (images, currentImageObject) => {
  return (
    images.reduce((prev, image) => {
      if (image.group === currentImageObject.id) {
        prev++;
      }
      return prev;
    }, 0) >= currentImageObject.imageQuantityRequired
  );
};

export const hasAlwaysRequiredPhotos = (array, group) => array.includes(group);

export const allRequiredPhotosUploaded = (imagesArray, requiredArray) =>
  requiredArray.every((requiredData) =>
    hasEnoughPhotosUploaded(imagesArray, requiredData)
  );

export const getIsInValid = (images, maxUploads) => {

  if (images.length > maxUploads) {
    return "You can only upload a maximum of 10 images.";
  }

  return false;
};

export const hasImageBeenUploaded = (image) => image.progress === 100;

export const tryAgain = (eventTarget, src = null) => {
  setTimeout(() => {
    reloadImg(eventTarget, src);
  }, 1000);
};

const reloadImg = (eventTarget, src) => {
  const source = src ? src : eventTarget.src;
  eventTarget.src = source;
};

export const createTagQueryString = (image) => {
  const mapOfImageTags = image?.tags?.map(
    (tagName) => `imageTags=${encodeURIComponent(tagName)}`
  );
  return mapOfImageTags.length > 1
    ? mapOfImageTags.join("&")
    : mapOfImageTags[0];
};

export const formatImagesForPost = (helper, imagesToFormat) => {
  const imageTags =
    helper.tag === "Vehicle introduction"
      ? [helper.tag, helper.id]
      : [helper.tag];

  const imagesForPost = imagesToFormat.map((image) => ({
    imageContent: image,
    srcUrl: URL.createObjectURL(image),
    tags: imageTags
  }));
  return imagesForPost;
};
